import React, {useState, useEffect} from 'react';
import { NavLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { sendPasswordResetEmail } from "firebase/auth";
import { auth, db } from "../../firebase";
import {
    collection,
    getDocs,
    deleteDoc,
    doc,
    onSnapshot,
    getDoc,
    serverTimestamp,
    setDoc
  } from "firebase/firestore";
import { useSelector, useDispatch } from 'react-redux'
import Navbar2 from './Navbar2';
import { toast } from 'react-toastify'
import config from '../../config';
import { register, reset } from '../../features/auth/authSlice'

import Spinner from '../Spinner'

var url = config.nav.url;

var login_link = url+'login';

const LostPassword = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [user, setUser] = useState({
        email : "",
        password : "",
        passwordConfirm : ""
    });

    const { usr, isLoading, isError, isSuccess, message } = useSelector(
        (state) => state.auth
      )

    useEffect(() => {
        // if(localStorage.getItem('user') != null){
        //     navigate('/');
        // }
        if (isError) {
        toast.error(message)
        window.alert('Erreur de connexion !')
        }

        if (isSuccess || usr) {
            navigate("/login")
        }

        dispatch(reset())
    }, [user, isError, isSuccess, message, dispatch])
    
    // Handle Inputs
    const handleInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;

        setUser({...user, [name]:value});
    }

    // Handle Submit
    const handleSubmit = async (event) => {
        event.preventDefault();
        sendPasswordResetEmail(auth, user.email).then(function(){
            window.alert("Vérifiez votre boite mail ...");
            navigate("/login");
        }).catch(function(e){window.alert(e)})    
    }

    if (isLoading) {
        return <Spinner />
      }

    return (
        <div>
            <Navbar2/>
            <div className="container m-5">
                <div className="justify-content-center">
                    <div className="col-md-5">
                                <h1 className="display-6 mt-3 pt-5">{t('forgot_password')} ?</h1>
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label">{t('forgot_text')}.</label>
                                        <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                                        name="email" value ={user.email} onChange={handleInput}/>
                                    </div>
                                    <button type="submit" class="btn btn-outline-primary mt-2 mb-2">{t('validate')}</button>
                                    <p>{t('have_credentials')} ? <NavLink to={login_link} className="deco_null">{t('log_in_here')}</NavLink></p>
                                </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LostPassword;
